<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <path
            class="a"
            d="M8.25002 20.772C7.96402 20.772 7.68202 20.718 7.41402 20.61L1.41402 18.21C0.55502 17.866 2.02703e-05 17.046 2.02703e-05 16.121V1.748C-0.00097973 1.557 0.0350203 1.367 0.10802 1.186C0.25702 0.814 0.54202 0.522 0.91002 0.365C1.09802 0.284 1.29702 0.243 1.50002 0.243C1.69102 0.243 1.87902 0.28 2.05902 0.352L7.97202 2.718C8.05702 2.752 8.14602 2.77 8.23702 2.771C8.24202 2.771 8.25902 2.771 8.26402 2.771C8.35402 2.769 8.44402 2.751 8.52902 2.717L14.914 0.162C15.182 0.055 15.463 0 15.75 0C16.037 0 16.318 0.054 16.585 0.162L22.585 2.562C23.445 2.906 24 3.726 24 4.652V11.252C24 11.666 23.664 12.002 23.25 12.002C22.836 12.002 22.5 11.666 22.5 11.252V4.652C22.5 4.343 22.315 4.07 22.029 3.955L16.5 1.744V7.502C16.5 7.916 16.164 8.252 15.75 8.252C15.336 8.252 15 7.915 15 7.502V1.744L9.08602 4.11C9.05702 4.121 9.02902 4.132 9.00002 4.142V11.252C9.00002 11.666 8.66402 12.002 8.25002 12.002C7.83602 12.002 7.50002 11.666 7.50002 11.252V4.142C7.47102 4.132 7.44302 4.121 7.41402 4.11L1.50002 1.744V16.121C1.50002 16.43 1.68502 16.703 1.97202 16.818L7.97202 19.218C8.06202 19.254 8.15502 19.272 8.25002 19.272C8.34502 19.272 8.43902 19.254 8.52802 19.218C8.61702 19.182 8.71102 19.164 8.80702 19.164C9.11502 19.164 9.38902 19.349 9.50302 19.635C9.65702 20.019 9.46902 20.457 9.08502 20.61C8.81802 20.717 8.53602 20.772 8.25002 20.772Z"
        />
        <path
            class="a"
            d="M23.25 24.002C23.05 24.002 22.861 23.924 22.72 23.782L20.177 21.239C19.126 22.056 17.834 22.502 16.5 22.502C13.192 22.502 10.5 19.81 10.5 16.502C10.5 13.194 13.192 10.502 16.5 10.502C19.808 10.502 22.5 13.194 22.5 16.502C22.5 17.835 22.054 19.128 21.237 20.179L23.78 22.722C24.072 23.014 24.072 23.49 23.78 23.783C23.639 23.924 23.45 24.002 23.25 24.002ZM16.5 12.002C14.019 12.002 12 14.021 12 16.502C12 18.983 14.019 21.002 16.5 21.002C18.981 21.002 21 18.983 21 16.502C21 14.021 18.981 12.002 16.5 12.002Z"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'MapSearchIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: currentColor;
    stroke: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
